/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'HomeGroupingSelector';

const classes = {
  groupButtonContainer: `${PREFIX}-groupButtonContainer`,
  groupButton: `${PREFIX}-groupButton`,
  groupButtonIcon: `${PREFIX}-groupButtonIcon`,
  groupButtonHint: `${PREFIX}-groupButtonHint`,
};

const Root = styled(Box)(({theme}) => ({
  height: '48px',
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  background: 'transparent',
  borderRadius: '8px',
  border: '1px solid #383838',
  color: '#8B8B8B',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',

  [`& .${classes.groupButton}`]: {
    height: '100%',
    borderRadius: '8px',
    background: '#2B2B2B',
    padding: theme.spacing(0, 4, 0, 4),
    '& .MuiTypography-root': {
      color: '#F1F1F1',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '16px',
      width: '120px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'left',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  [`& .${classes.groupButtonIcon}`]: {
    marginLeft: theme.spacing(2),
    color: '#F1F1F1',
    fontSize: '16px',
  },
  [`& .${classes.groupButtonHint}`]: {
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(2),
    '&:hover': {
      background: theme.palette.figma_gray_dark_1?.main,
    },
  },
}));

export {classes as HomeGroupingSelectorClasses, Root as HomeGroupingSelectorRoot};
